export default "__VITE_ASSET__3f768996__$_?component__"